import React from "react";

const BookingSourceCard = ({ bookingTypeCounts = {} }) => {
  const sources = [
    { key: "userApp", label: "User App", icon: "📱" },
    { key: "admin", label: "Admin Panel", icon: "💻" },
  ];

  return (
    <div className="w-[95%] xl:w-1/3 bg-[#FBB033] rounded-3xl p-7 flex flex-col gap-6 shadow-lg">
      {/* Header */}
      <div className="flex items-center gap-4">
        <div className="bg-white/20 p-2 rounded-xl">
           <span className="text-2xl">📊</span>
        </div>
        <div>
          <p className="text-[#39354E] text-sm font-medium">Booking Sources</p>
          <p className="text-[#39354E] text-xl font-bold">Distribution</p>
        </div>
      </div>

      <div className="w-full h-[1px] bg-[#ECF1FF]" />

      <div className="flex flex-col gap-4">
        {sources.map(({ key, label, icon }) => {
          const stats = bookingTypeCounts[key] || { total: 0, verified: 0 };
          return (
            <div key={key} className="bg-white/40 rounded-2xl p-4 flex flex-col gap-3 transition hover:bg-white/60">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                  <span>{icon}</span>
                  <span className="text-[#39354E] font-bold">{label}</span>
                </div>
                <div className="bg-[#39354E] text-white text-xs px-2 py-1 rounded-lg font-bold">
                  {stats.total} Total
                </div>
              </div>
              
              <div className="flex justify-between items-center text-sm">
                <span className="text-[#39354E]/70 font-medium">Verified</span>
                <span className="text-emerald-700 font-bold bg-emerald-100 px-2 py-0.5 rounded-md">
                  {stats.verified}
                </span>
              </div>

              {/* Progress Bar */}
              <div className="w-full bg-black/10 h-2 rounded-full overflow-hidden">
                <div 
                  className="bg-emerald-500 h-full transition-all duration-500" 
                  style={{ width: stats.total > 0 ? `${(stats.verified / stats.total) * 100}%` : '0%' }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BookingSourceCard;
